module.exports = __webpack_public_path__ + "static/mountain-view-c409b4ec1184f07fc3a9a2324514db4c.png";